import { actions } from '@makemydeal/dr-offer-redux';

const buildMeta = (analyticsName: string) => ({
    middleware: {
        payment: true,
        analytics: {
            eventName: analyticsName
        }
    }
});

/* NOTE: These overrides are intended to be used in place of the immediate/debounced actions found directly in offer-redux.
 * New, not previously used fields taking input will be added directly to dr-offer-redux.
 */

export const updateDownPayment = (downPayment: number) => ({
    type: actions.UPDATED_DOWN_PAYMENT_IMMEDIATE,
    payload: downPayment,
    meta: buildMeta('DR_DOWN_PAYMENT_CHANGED')
});

export const updateDealDeposit = (dealDeposit: number) => ({
    type: actions.UPDATE_DEAL_DEPOSIT,
    payload: dealDeposit,
    meta: buildMeta('DR_DEAL_DEPOSIT_CHANGED')
});

export const updateOfferPrice = (offerPrice: number) => ({
    type: actions.UPDATED_OFFER_PRICE_IMMEDIATE,
    payload: offerPrice,
    meta: buildMeta('DR_OFFER_PRICE_CHANGED')
});

export const applyRecommendedVehiclePaymentDetails = (
    paymentPayload: {
        downPayment: number;
        sellingPrice: number;
        retailPrice: number;
        buyRate: number;
        apr: number;
        sellRate?: number;
        vehicle: any;
    },
    options?: { skipAiRefresh?: boolean; skipRateOverride?: boolean }
) => ({
    type: actions.APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS,
    payload: paymentPayload,
    meta: {
        ...buildMeta('DR_APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS'),
        // Seeding a brand-new scenario (Add New Scenario) applies payment but is not a user deal edit, so
        // flag it to suppress the AI "refresh" (stale) button. aiMiddleware honors meta.skipAiRefresh.
        ...(options?.skipAiRefresh ? { skipAiRefresh: true } : {}),
        // Seed price/down payment but leave the rate to the deal's auto-select program, so the new vehicle
        // prices under that program instead of pinning the rate carried in the payload.
        ...(options?.skipRateOverride ? { skipRateOverride: true } : {})
    }
});
